import * as madnes from "../../framework/src/engine/madnes/madnes";
import * as MV from "../../framework/src/engine/madnes/madnes_variables";

import {madnes_set_win_factors} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_sprite} from "../../framework/src/engine/madnes/madnes";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";
import {jb_on_add_result, rotate_run} from "../jokerboom_core";
import {reels_print_desk} from "../jokerboom_reels";
import {jb_print_reels} from "../jokerboom_core_printer";
import {
    jb_infomenu_close, js_infomenu_home,
    jb_infomenu_init, jb_infomenu_left,
    jb_infomenu_open, jb_infomenu_right,
    jb_infomenu_update,
    openinfo
} from "../jokerboom_infomenu";
import {jb_end_round_recalced} from "../jokerboom_ctrl";
import {main_phaser} from "../../framework/src/engine/madnes/MadnesApp";

export const infotexts_languages = [
    "bg", "cs","de", "en", "es", "fi", "fr", "hr", "it", "no", "pl", "ro", "ru", "sk", "sr", "sv", "tr", "pt", "es-mx", "nl"
];

export function initGame(gameset) {

    MV.set_config_load_symbols(false);

    // set_show_money_pos_y(he * 0.46);

    madnes.set_ico_size(300, 194);

    madnes_set_win_factors(25, 50, 125);

    madnes_set_sprite("coins", 152, 152);

    // madnes_set_sprite('_sprite', 194, 180);
    // madnes_set_sprite('_blur', 194, 180);

    // madnes_set_default_volume(0.8);
}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            end_round_recalced(eventName, data);
            break;

        case GAME_EVENTS.GAME_ADD_RESULT:
            on_add_result(data);
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            // show_all_lines();
            infomenu_update();
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}

export function game_start() {
    main_phaser.tweens.frameBased = true;
    rotate_run()
}

export function print_desk() {
    reels_print_desk()
}

export function print_reels() {
    jb_print_reels();
}

export function infomenu_init() {
    jb_infomenu_init();
    jb_infomenu_update();
}

export function infomenu_open() {
    jb_infomenu_open();
}

export function infomenu_close() {
    jb_infomenu_close();
}

export function is_info_open() {
    return openinfo;
}

export function infomenu_left() {
    jb_infomenu_left();
}

export function infomenu_right() {
    jb_infomenu_right();
}

export function infomenu_update() {
    jb_infomenu_update();
}

export function infomenu_home() {
    js_infomenu_home();
}

export function on_add_result({ addResult, symbolsMatrix }) {
    jb_on_add_result({ addResult, symbolsMatrix });
}

export function end_round_recalced(eventName, {autostart}) {
    jb_end_round_recalced();

    if(!autostart) {
        end_round_no_autostart();
    }
}

export function end_round_no_autostart() {}

function freespins_end_round(eventName, {ended}) {}

export function get_preinfo() {
    return;
}

export function preinfo_close() {}